<template>
  <div class="card-bg-details shadow">
    <div class="card-body-track">
      <div
        class="t-details w-100 d-flex flex-column justify-content-center align-items-center"
      >
        <BaseIcon :width="150" :height="150" :padding="30" :name="trackIcon" />
        <div class="t-heading mt-2">{{ trackName }}</div>
        <div class="t-subheading p-0 m-0">{{ trackCategory }}</div>
      </div>

      <div
        class="row mt-4 d-flex flex-column justify-content-center align-items-center"
      >
        <div class="d-flex col-12">
          Status:
          <div
            v-if="approveStatus == 1"
            class="t-status mx-4 bg-track-status rounded"
          >
            APPROVED
          </div>
          <div v-else>
            <div
              v-if="trackStatus === 'Complete'"
              class="t-status mx-4 bg-track-status rounded"
            >
              {{ trackStatus }}
            </div>

            <div v-else class="t-status mx-4 bg-track-status-danger rounded">
              {{ trackStatus }}
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-12 d-flex justify-content-start align-items-center">
          Date:
          <div class="t-status mx-4">
            {{ details ? details.timestamp.split("T")[0] : "" }}
          </div>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-12 d-flex justify-content-start align-items-center">
          Project:
          <div class="mx-4">
            {{ details && details.projectname ? details.projectname : "null" }}
          </div>
        </div>
      </div>
      <div>
        <div v-if="!userfiles">
          <div class="upload-item-box my-2">
            <input
              type="file"
              name="fields[assetsFieldHandle][]"
              id="assetsFieldHandle"
              class="d-none"
              @change="onChange"
              ref="file"
              multiple
              accept="audio/*,.zip"
              style="dispay: none"
            />
            You need to
            <span
              v-on:click="onfilesUpload"
              style="color: tomato; cursor: pointer"
              >upload new files.</span
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="w-100 del-t d-flex justify-content-center align-items-center"
      v-on:click="onDelete"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        fill="currentColor"
        class="bi bi-trash"
        viewBox="0 0 16 16"
      >
        <path
          d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
        />
        <path
          fill-rule="evenodd"
          d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
        />
      </svg>
      <p class="p-0 m-0 mx-2">DELETE</p>
    </div>

    <div
      v-if="details && details.status === 'Complete' && approveStatus == 0"
      class="w-100 appr-t d-flex justify-content-center align-items-center"
      v-on:click="onApprove"
    >
      <p class="p-0 m-0 mx-2">APPROVE</p>
    </div>
    <div v-else></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      trackName: this.details.trackname,
      trackCategory: this.details.category, //,
      stems: [],
      refiles: [],
      uploadProgress: 0
    };
  },
  props: {
    showExisting: Number,
    details: Object,
    trackStems: Array,
    refStems: Array
  },
  computed: {
    getProgress() {
      this.uploadProgress = this.$store.state.trackData.uploadProgress;
      return 0;
    },
    trackIcon() {
      return this.trackcategory == "Music"
        ? "music"
        : this.trackcategory == "TV and Film"
        ? "film"
        : "speaker";
    },
    trackStatus() {
      return this.details.status;
    },
    approveStatus() {
      return this.details.approved;
    },
    userfiles() {
      return this.trackStems.length > 0;
    }
  },
  methods: {
    onfilesUpload() {
      document.querySelector("#assetsFieldHandle").click();
    },
    onChange(e) {
      if (e.target.files.length > 0) {
        for (let i = 0; i < e.target.files.length; i++) {
          this.refiles.push(e.target.files[i]);
        }
        this.uploadFunc(this.refiles, this.$route.params.id);
      } else {
        return;
      }
    },
    uploadFunc(files, trackId) {
      this.$swal
        .fire({
          title: "Uploading files!",
          text: "processing in progress...",
          imageUrl: "https://api.getmxd.com/assets/spinner.gif",
          imageHeight: 200,
          imageWidth: 200,
          imageAlt: "loading...",
          animation: false,
          buttons: false,
          showConfirmButton: false,
          closeOnClickOutside: false,
          didOpen: () => {
            Swal.showLoading();
            const b = Swal.getHtmlContainer().querySelector("b");
            b.textContent = this.uploadProgress;
          },
          willClose: () => {}
        })
        .then(result => {
          /* Read more about handling dismissals below */
          if (result.dismiss === Swal.DismissReason.timer) {
            console.log("I was closed by the timer");
          }
        });
      let trackName = this.trackName;
      let date = this.formattedDate;

      files.map((track, index) => {
        let fileExt = track.name.split(".").pop();

        let name =
          localStorage.getItem("mxdUserName") +
          "_Track_" +
          "1" +
          "_" +
          track.name
            .replace("adlib", "adlibs")
            .split("#")
            .join("_")
            .split("&")
            .join("_")
            .split("?")
            .join("_")
            .split(".")
            .slice(0, track.name.split(".").length - 1)
            .toString()
            .split(" ")
            .join("-") +
          "." +
          fileExt;
        let key =
          localStorage.getItem("mxdUserName") +
          "/" +
          date +
          "/" +
          trackName.split(" ").join("-") +
          "/" +
          name;

        let xhr = new XMLHttpRequest();

        this.$store
          .dispatch("apiEvents/getS3Sig", {
            fileName: track.name,
            fileType: track.type,
            key: key
          })
          .then(response => {
            xhr.open("PUT", response.data.signedRequest);
            xhr.setRequestHeader("Content-Disposition", "attachment");
            this.$store
              .dispatch("apiEvents/setNewMixElement", {
                trackId: trackId,
                elementGroup: "",
                elementUrl: "https://s3.amazonaws.com/quickmix/" + key,
                elementName: track.name
                  .split(".")
                  .slice(0, track.name.split(".").length - 1)
                  .toString()
              })
              .then(() => {});
            this.$store
              .dispatch("apiEvents/sendUploadEmail", {
                trackName: trackName,
                mixId: "",
                errors: "",
                user: localStorage.getItem("mxdUserName")
              })
              .then(() => {})
              .then(() => {
                this.$store.dispatch("trackData/setRefStemElements", trackId);
                this.$store.dispatch("trackData/setTrackUploadStatus", {
                  status: 0
                });
              });

            xhr.onreadystatechange = function() {
              if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                  document.location.href = "/track" + trackId;
                } else {
                  alert("Could not upload file.");
                }
              }
            };

            xhr.send(track);
          });
      });
    },
    onDelete: async function() {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!"
        })
        .then(result => {
          if (result.isConfirmed) {
            this.$store
              .dispatch("apiEvents/deleteTrackByTrackId", {
                trackId: this.$route.params.id,
                useremail: this.$store.state.apiEvents.username
              })
              .then(() => {
                this.$swal
                  .fire("Deleted!", "Your track has been deleted.", "success")
                  .then(() => {
                    this.$router.push({ name: "dashboard" });
                  });
              });
          }
        });
    },
    onApprove: function() {
      this.$swal
        .fire({
          title:
            "Once you approve this mix, no revisions/changes can be made. If you want to make a change, you will need to start a new song.",
          icon: "info",
          showCancelButton: true,
          timer: 6000,
          timerProgressBar: true,
          confirmButtonText: "Approve",
          didOpen: toast => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          }
        })
        .then(result => {
          if (result.isConfirmed) {
            this.$store
              .dispatch("apiEvents/updateApproveStatus", {
                trackId: this.$route.params.id,
                userId: localStorage.getItem("userId"),
                useremail: this.$store.state.apiEvents.username
              })
              .then(result => {
                if (result.status == 200) {
                  this.$swal
                    .fire("Marked as Approved!", "", "success")
                    .then(() => {
                      // this.$router.push({ name: "track", params: { id: this.$route.params.id } });
                      this.$router.go();
                    });
                } else {
                }
              });
            // Swal.fire('Saved!', '', 'success')
          }
        });
    }
  }
};
</script>

<style>
.card-bg-details {
  overflow: hidden;
  background-color: #1a1c22;
  border-radius: 20px;
}

.del-t,
.appr-t {
  height: 40px;
  cursor: pointer;
}

.del-t {
  border-radius: 0px 0px 0px 0px;
  background-color: rgb(228, 44, 44) !important;
}

.appr-t {
  border-radius: 0px 0px 20px 20px;
  background-color: rgb(44, 228, 130) !important;
}

.del-t:hover {
  background-color: rgb(243, 59, 59) !important;
}

.bg-track-status {
  padding: 3px;
  background-color: #00b712;
  background-image: linear-gradient(315deg, #00b712 0%, #5aff15 90%);
}

.bg-track-status-danger {
  padding: 3px;
  background-color: #6b0f1a;
  background-image: linear-gradient(315deg, #6b0f1a 0%, #b91372 74%);
}

.t-details .t-heading {
  font-size: 26px;
  font-weight: bold;
}

.t-status {
  font-size: 12px;
}
</style>
